import React from "react";
import { Button, Box, SimpleGrid } from "@chakra-ui/react";
import {
  ANSWER_TEMPLATE,
  normalizeAnswerTemplate,
} from "../constants/answerTemplates";

export const MINISTRY_SPECIAL_CHARACTERS = [
  "□", "○", "-", "※", "■", "●", "◎", "▣",
  "‘", "’", "“", "”", "「", "」", "『", "』", "·", "§",
  "+", "÷", "×", "=", "{", "}", "(", ")", "[", "]",
  "℃", "㎘", "㎦", "㎧", "㎜", "㎝", "㎞", "㎠", "㎡", "㎢",
  "㎤", "㎥", "㎎", "㎏", "ℓ",
  "Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ",
  "ⅰ", "ⅱ", "ⅲ", "ⅳ", "ⅴ", "ⅵ", "ⅶ", "ⅷ", "ⅸ", "ⅹ",
  "①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩",
  "㉠", "㉡", "㉢", "㉣", "㉤", "㉥", "㉦", "㉧", "㉨", "㉩", "㉪", "㉫", "㉬", "㉭",
  "㉮", "㉯", "㉰", "㉱", "㉲", "㉳", "㉴", "㉵", "㉶", "㉷", "㉸", "㉹", "㉺", "㉻",
  "⑴", "⑵", "⑶", "⑷", "⑸", "⑹", "⑺", "⑻", "⑼", "⑽",
  "㈀", "㈁", "㈂", "㈃", "㈄", "㈅", "㈆", "㈇", "㈈", "㈉", "㈊", "㈋", "㈌", "㈍",
  "㈎", "㈏", "㈐", "㈑", "㈒", "㈓", "㈔", "㈕", "㈖", "㈗", "㈘", "㈙", "㈚", "㈛",
  "甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸",
];

const DEFAULT_SPECIAL_CHARACTERS = [
  "①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩",
  "Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ",
  "ⅰ", "ⅱ", "ⅲ", "ⅳ", "ⅴ", "ⅵ", "ⅶ", "ⅷ", "ⅸ", "ⅹ",
  "「", "」", "『", "』", "§", "甲", "乙", "丙", "丁", "戊", "己", "㎡",
];

const SpecialCharacters = ({ onCharacterClick, templateType }) => {
  const isMinistryTemplate =
    normalizeAnswerTemplate(templateType) ===
    ANSWER_TEMPLATE.MINISTRY_OF_JUSTICE;
  const characters = isMinistryTemplate
    ? MINISTRY_SPECIAL_CHARACTERS
    : DEFAULT_SPECIAL_CHARACTERS;

  if (isMinistryTemplate) {
    return (
      <SimpleGrid columns={6} spacing="0" width="204px">
        {characters.map((character) => (
          <Button
            key={character}
            type="button"
            aria-label={`${character} 입력`}
            title={`${character} 입력`}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onCharacterClick(character)}
            minW="30px"
            width="30px"
            height="30px"
            padding="0"
            margin="2px"
            border="1px solid transparent"
            borderRadius="4px"
            backgroundColor="#cececc"
            color="#212529"
            fontFamily='Pretendard, "Malgun Gothic", sans-serif'
            fontSize="18px"
            fontWeight="700"
            lineHeight="27px"
            _hover={{ backgroundColor: "#bdbdbb" }}
            _active={{ backgroundColor: "#aeadab" }}
          >
            {character}
          </Button>
        ))}
      </SimpleGrid>
    );
  }

  return (
    <Box>
      {characters.map((character) => (
        <Button
          padding="0px"
          border="0"
          key={character}
          onClick={() => onCharacterClick(character)}
          variant="outline"
        >
          {character}
        </Button>
      ))}
    </Box>
  );
};

export default SpecialCharacters;
